import React from 'react';
import { SocialShareButtons } from './SocialShareButtons';

interface AdShareProps {
  adId?: string;
  adTitle?: string;
}

const AdShare: React.FC<AdShareProps> = ({ adId, adTitle }) => {
  return (
    <div className="space-y-2">
      <h2 className="text-sm font-semibold text-slate-900 dark:text-slate-100">Share this ad</h2>
      <p className="text-xs text-slate-600 dark:text-slate-400">
        Generate smart links for TELLURVISION billboards and share-ready posts for your social
        channels.
      </p>
      <SocialShareButtons adId={adId} adTitle={adTitle} />
    </div>
  );
};

export default AdShare;
export { AdShare };
